import { assistantService } from "../services/user";

export const globalRoles = {
    SUPERADMIN: 'SuperAdmin',
    OWNER: 'Owner',
    ADMIN: 'Admin',
    PATIENT: 'Patient',
    PHYSICIAN: 'Physician',
    LIBRARY_MANAGER: 'LibraryManager',
    ASSISTANT: 'Assistant',
    CCM_MANAGER: 'CcmManager',
    CCM_COORDINATOR: 'CcmCoordinator',
  };